module.exports = __webpack_public_path__ + "img/awards.438e655.webp";